import {
    ORDO_ORDER_ID,
    ORDO_SMART_ID_CHECK,
    CLEAR_ORDER_DATA,
    PAYMENT_STATUS,
    STRIPE_ORDER,
    JUDO_ORDER,
    SUMUP_ORDER,
    SUMUP_STATUS,
    SYNAPTO_ORDER,
    SYNAPTO_CONFIG,
} from 'App/store/constants';
const initialState = {
    ordoOrder: null,
    paymentLink: null,
    fondyOrder: null,
    worldpayOrder: null,
    pay360Order: null,
    androidStatus: null,
    judoOrder: null,
    paymentStatus: null,
    stripePaymentIntent: null,
    sumUpOrder: null,
    synaptoPaymentIntent: null,
    synaptoConfig: null,
    // HTTP 409 from synapto/create-order means the driver has not finished
    // registering with Synapto. Held separately so the screen can show a
    // specific message instead of a spinner that never resolves.
    synaptoDriverNotOnboarded: false,
    errors: {},
    loading: false,
};

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ORDO_SMART_ID_CHECK.PENDING:
            return { ...state, loading: true };

        case ORDO_SMART_ID_CHECK.SUCCESS:
            return {
                ...state,
                ordoOrder: action.payload.data,
                loading: false,
            };

        case ORDO_SMART_ID_CHECK.FAILURE:
            return {
                ...state,
                ordoOrder: null,
                loading: false,
                errors: action.payload,
            };

        case ORDO_ORDER_ID.PENDING:
            return { ...state, loading: true };

        case ORDO_ORDER_ID.SUCCESS:
            return { ...state, loading: false, paymentLink: action.payload.data };

        case ORDO_ORDER_ID.FAILURE:
            return { ...state, ordoOrder: null, loading: false, errors: action.payload };

        case STRIPE_ORDER.PENDING:
            return { ...state, loading: true };
        case STRIPE_ORDER.SUCCESS:
            const sorder = action.payload.data;
            return { ...state, loading: false, stripePaymentIntent: sorder };
        case STRIPE_ORDER.FAILURE:
            return { ...state, stripePaymentIntent: null, loading: false, errors: action.payload };

        case JUDO_ORDER.PENDING:
            return { ...state, loading: true };
        case JUDO_ORDER.SUCCESS:
            const jorder = action.payload.data;
            //console.log({jorder: action.payload});
            return { ...state, loading: false, judoOrder: jorder };
        case JUDO_ORDER.FAILURE:
            return { ...state, judoOrder: null, loading: false, errors: action.payload };

        case SUMUP_ORDER.PENDING:
            return { ...state, loading: true };
        case SUMUP_ORDER.SUCCESS:
            return { ...state, loading: false, sumUpOrder: action.payload.data };
        case SUMUP_ORDER.FAILURE:
            return { ...state, sumUpOrder: null, loading: false, errors: action.payload };

        case SUMUP_STATUS.PENDING:
            return { ...state, loading: true };
        case SUMUP_STATUS.SUCCESS:
            return { ...state, loading: false };
        case SUMUP_STATUS.FAILURE:
            return { ...state, loading: false, errors: action.payload };

        case SYNAPTO_CONFIG.PENDING:
            return { ...state, loading: true };
        case SYNAPTO_CONFIG.SUCCESS:
            return { ...state, loading: false, synaptoConfig: action.payload.data };
        case SYNAPTO_CONFIG.FAILURE:
            return { ...state, synaptoConfig: null, loading: false, errors: action.payload };

        case SYNAPTO_ORDER.PENDING:
            return { ...state, loading: true, synaptoDriverNotOnboarded: false };
        case SYNAPTO_ORDER.SUCCESS:
            return { ...state, loading: false, synaptoPaymentIntent: action.payload.data, synaptoDriverNotOnboarded: false };
        case SYNAPTO_ORDER.FAILURE:
            // Http.ts drops the response body's `code`, but forwards the HTTP
            // status. 409 is only ever returned for DRIVER_NOT_ONBOARDED.
            return {
                ...state,
                synaptoPaymentIntent: null,
                loading: false,
                synaptoDriverNotOnboarded: action.status === 409,
                errors: action.payload,
            };

        case PAYMENT_STATUS:
            return { ...state, paymentStatus: action.payload };

        case CLEAR_ORDER_DATA:
            return { ...state, ordoOrder: null, judoOrder: null, sumUpOrder: null, synaptoPaymentIntent: null, synaptoDriverNotOnboarded: false, paymentStatus: null };
        default:
            return state;
    }
};

export default reducer;
